export default {
  title: "Edit profile",
  personalData: "Personal information",
  companyData: "Company information",

  companyTypes: "Сompany business activity",
  companySizes: "Choose if this relates to your company business",
  companyScope: "Your company's scope",
  companyProductRole: "Application spheres of your products and services",

  changePassword: "Change password",
  changePasswordTitle: "Password change",
  oldPassword: "Current password",
  newPassword: "New password",
  passwordConfirmation: "New password confirmation",
  changePasswordSuccess: "Password changed",

  save: "Save",
  saveSuccess: "Saved successfully",
  saving: "Saving...",

  saveError: "Could not update profile data: {err}",

  changePasswordWrongOldPasswordError: "Old password is incorrect",
  changePasswordServerError: "Could not change password"
};
